import { LatLngBoundsLiteral } from './models/coordinate-search.model';

/** Build a ~radiusMeters viewport around a point for Google Maps fitBounds. */
export function buildViewportAroundPoint(
  lat: number,
  lng: number,
  radiusMeters: number
): LatLngBoundsLiteral {
  const latDelta = radiusMeters / 111320;
  const lngDelta = radiusMeters / (111320 * Math.cos((lat * Math.PI) / 180) || 1);
  return {
    north: lat + latDelta,
    south: lat - latDelta,
    east: lng + lngDelta,
    west: lng - lngDelta,
  };
}

export function serializeCoordinateLocationPayload(payload: {
  lat: number;
  lng: number;
  name: string;
  viewport: LatLngBoundsLiteral | null;
  origin?: string;
}): string {
  return JSON.stringify({
    lat: payload.lat,
    lng: payload.lng,
    name: payload.name,
    viewport: payload.viewport,
    origin: payload.origin ?? 'coordinate',
  });
}
